import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container user-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Login to Joystick")
], -1)
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "welcome" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Welcome, glad to see you again!")
], -1)
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { type: "submit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          autocomplete: "off",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.login()), ["prevent"]))
        }, [
          _createElementVNode("label", null, [
            _createTextVNode(" Email "),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              type: "email",
              required: "",
              name: "email",
              placeholder: "Email",
              autocomplete: "email"
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ]),
          _createElementVNode("label", null, [
            _createTextVNode(" Password "),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              type: "password",
              required: "",
              name: "password",
              placeholder: "Password",
              autocomplete: "current-password"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_6, [
            _createTextVNode(" Log In to Joystick ")
          ])), [
            [_directive_loading, _ctx.loadingStatus]
          ])
        ], 32)
      ])
    ])
  ]))
}